import React, { useEffect } from "react";
import { API, graphqlOperation, Auth } from "aws-amplify";
import { useHistory } from "react-router-dom";
import Tooltip from "../../_shared/components/Tooltip";
import Modal from "react-modal";
import { useState } from "react";
import { customModalStyles } from "../../../_shared/components/Modal/ModalStyles";
import Loading from "../../../_shared/components/Loading/Loading";
import TickerAlert from "./ticker-modal/components/TickerAlert";
import RequestTickerAlert from "../RequestTickerAlert";
import "./KissViewAndTicker.scss";

Modal.setAppElement("#root");

function KissViewAndTicker(props) {
  const history = useHistory();
  const url = window.location.href.split("/");

  const [search, setSearch] = React.useState("");
  const [results, setResults] = React.useState([]);
  const [tickerSymbolInputEmpty, setTickerSymbolInputEmpty] =
    React.useState(false);
  const [kiss, setKiss] = React.useState(
    localStorage.getItem("kiss-view") === "kiss" ? true : false,
  );
  const [view, setView] = React.useState(localStorage.getItem("view"));
  const [tickerAlert, setTickerAlert] = React.useState(true);
  const [response, setResponse] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [ticker, setTicker] = useState("");
  const [modalRequestOpen, setModalRequestOpen] = useState(false);
  const [name, setName] = useState("");
  const [modalIsOpen, setIsOpen] = useState(false);
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("test@example.com");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [handler, setHandler] = useState("");

  const ref = React.useRef();

  function makeThisURLFriendly(panelName) {
    return (panelName = panelName.toLowerCase().replaceAll(" ", "-"));
  }
  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (
        results.length > 0 &&
        ref.current &&
        !ref.current.contains(e.target)
      ) {
        setTimeout(() => {
          setResults([]);
          setSearch("");
        }, 100);
      } else if (
        results.length === 0 &&
        ref.current &&
        !ref.current.contains(e.target)
      )
        setTimeout(() => {
          setSearch("");
        }, 100);
    };
    document.addEventListener("mouseup", checkIfClickedOutside);
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mouseup", checkIfClickedOutside);
    };
  }, [results]);

  //Detecting screen size change
  useEffect(() => {
    const handling = (e) => setHandler({ matches: e.matches });
    window
      .matchMedia("(max-width: 480px)")
      .addEventListener("change", handling);
  }, [handler]);

  useEffect(() => {
    //if someone accesses kiss view using the url instead of toggle, the logic below will
    //check the url and adjust the toggle accordingly
    if (
      localStorage.getItem("kiss-view") === null ||
      url[url.length - 1] === "kiss-view"
    ) {
      localStorage.setItem("kiss-view", "kiss");
      setKiss(true);
    } else if (url[url.length - 1] !== "kiss-view") {
      localStorage.setItem("kiss-view", "");
      setKiss(false);
    } else if (
      localStorage.getItem("view") === null ||
      url[url.length - 1] === "view"
    ) {
      localStorage.setItem("view", "basic");
      setKiss(true);
    } else if (url[url.length - 1] !== "view") {
      localStorage.setItem("view", "");
      setKiss(false);
    }
  }, [url]);

  useEffect(() => {
    const getEmail = async () => {
      const userData = (await Auth.currentSession()).getIdToken().payload;
      setEmail(userData.email);
    };
    getEmail();
  }, []);

  function closeModal() {
    setSuccess(false);
    setIsOpen(false);
    setLoading(true);
    setTickerSymbolInputEmpty(false);
  }

  async function submit() {
    if (subject.trim().length === 0) {
      setTickerSymbolInputEmpty(true);
      return;
    }

    //Get the user data
    const userData = (await Auth.currentSession()).getIdToken().payload;
    setEmail(userData.email);
    //Now we submit the message
    setLoading(true);
    await API.post("auth", "/cognito/zendesk", {
      body: {
        user: userData,
        subject: subject,
        message: message,
      },
    });
    setSuccess(true);
    setSubject("");
    setMessage("");
    setLoading(false);
  }

  return (
    <>
      <div className="kiss-view-and-ticker">
        <Tooltip />
        <div className="kiss-view">
          <div
            className="compact-button"
            onClick={() => props.setCompactMode(!props.compactMode)}
            style={{
              fontSize: "18px",
              marginLeft: "20px",
              border: "1px dashed",
              borderColor: props.compactMode ? "#75ce41" : "#bbb8b8",
              cursor: "pointer",
            }}
          >
            <span>
              <i
                style={{
                  fontSize: "9px",
                  position: "relative",
                  top: props.compactMode ? "-8px" : "4px",
                  left: props.compactMode ? "8px" : "8px",
                  color: "#75ce41",
                }}
                className="fas fa-arrow-up"
              ></i>
              <i
                style={{
                  fontSize: "9px",
                  position: "relative",
                  top: props.compactMode ? "4px" : "-8px",
                  right: props.compactMode ? "0px" : "0px",
                  color: "#75ce41",
                }}
                className="fas fa-arrow-down"
              ></i>
            </span>
            <span
              style={{
                fontSize: "18px",
                position: "relative",
                right: "5px",
                bottom: props.compactMode ? "-.5px" : "0px",
              }}
            >
              &nbsp; {props.compactMode ? "=" : "≡"}
            </span>
          </div>
          <div
            style={{
              color: "white",
              position: "relative",
            }}
            className="info-icon compact"
            data-tip="Compact Mode - Reduces height of cells to fit more rows in table view."
          >
            i
          </div>
          <div
            className="guidedTour7"
            style={{ display: "flex", alignItems: "center" }}
          >
            {["basic", "intermediate", "advanced"].map((key) => (
              <>
                <div
                  style={{
                    marginLeft: 20,
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                  onClick={() => {
                    if (!view[key]) {
                      setView(key);
                      localStorage.setItem("view", key);
                      props.setRefreshKiss(new Date());
                      history.push(
                        `/dashboard/${makeThisURLFriendly(
                          props.tab.name,
                        )}/${key}-view`,
                      );
                    }
                  }}
                >
                  <input
                    style={{ marginRight: 7.5 }}
                    type="checkbox"
                    checked={view === key}
                  />
                  <span>
                    {`${key[0].toUpperCase()}${key.slice(1, key.length)}`} View
                  </span>
                </div>
                <div
                  style={{
                    color: "white",
                    position: "relative",
                  }}
                  className="info-icon compact"
                  data-tip={
                    key === "basic"
                      ? "A basic view of your dashboard with clear signals."
                      : key === "intermediate"
                      ? "An intermediate view of your dashboard showing summary signals and hiding many of the detailed numerical values, for a quick look at securities' signals."
                      : key === "advanced"
                      ? "An advanced view of your dashboard showing all signals and detailed numerical values."
                      : ""
                  }
                >
                  i
                </div>
              </>
            ))}
          </div>
        </div>
        <div ref={ref}>
          {!props.tab?.longbow_panel && (
            <div
              style={{ border: "2px solid #58af26" }}
              className="ticker-search"
            >
              <input
                type="text"
                placeholder="Add Ticker"
                value={search}
                style={
                  !window.matchMedia("(max-width: 480px)").matches
                    ? { width: 400 }
                    : { width: "295px" }
                }
                // only allow letters
                onKeyDown={(e) => {
                  if (!/[a-zA-Z]/.test(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={async (e) => {
                  setSearch(e.target.value);
                  if (e.target.value.length > 0) {
                    const response1 = (
                      await API.graphql(
                        graphqlOperation(`{
                        search_tickers(where: {ticker: {_eq: "${e.target.value.toUpperCase()} US Equity"}}, limit: 1) {
                          ticker
                          name
                          exists
                          requested {
                            id
                          }
                        }
                      }`),
                      )
                    ).data.search_tickers;

                    const response2 = (
                      await API.graphql(
                        graphqlOperation(`{
                        search_tickers(where: {_and: [{ticker: {_nin: [${response1
                          .map((obj) => `"${obj.ticker}"`)
                          .join(",")}]}}, {_or: [{name: {_ilike: "${
                          e.target.value
                        }"}}, {ticker: {_ilike: "${
                          e.target.value
                        }%"}}]}]}, limit: 5, order_by: {name: asc, exists: desc}) {
                          ticker
                          name
                          exists
                          requested {
                            id
                          }
                        }
                      }`),
                      )
                    ).data.search_tickers;

                    setResults([]);
                    setTimeout(() => {
                      setResults([...response1, ...response2]);
                    }, 0);
                  } else {
                    setResults([]);
                  }
                }}
              />
              <i className="fas fa-search search-icon" />
            </div>
          )}
          {results.length > 0 ? (
            <div
              className="search-results"
              style={{
                // position: "absolute",
                // right: 40,
                // top: 140,
                backgroundColor: "#2e2e2e",
                zIndex: 4,
                width: !window.matchMedia("(max-width: 480px)").matches
                  ? 400
                  : "295px",
                cursor: "pointer",
              }}
            >
              {results.map((obj) => {
                let addedTicker = false;
                for (let i = 0; i < props.data.length; i++)
                  if (props.data[i].ticker === obj.ticker) addedTicker = true;
                return (
                  <div
                    key={obj.name}
                    className={
                      !obj.exists ? "ticker-available" : "ticker-unavailable"
                    }
                    style={{
                      padding: 10,
                      cursor: !obj.exists ? "not-allowed" : "pointer",
                    }}
                  >
                    <div
                      style={{ display: "flex", width: "100%" }}
                      onClick={async () => {
                        if (!obj.exists || addedTicker) return;
                        //Add the ticker!
                        const data = await API.graphql(
                          graphqlOperation(`mutation {
                      add_ticker(object: {ticker: "${obj.ticker}", panel_id: "${props.tab.id}"}) {
                        message
                        tickers_left
                        total_tickers
                        upgrade_plan_key
                        upgrade_plan_title
                        upgrade_message
                        payment_confirmation_message
                        payment_success_message
                      }
                    }`),
                        );
                        setTicker(obj.ticker);
                        setResponse(data.data.add_ticker);
                        setSearch("");
                        setTickerAlert(false);
                        setModalOpen(true);
                        props.setRefreshTable(new Date());
                        if (data.data.add_ticker.message === "success")
                          setResults([]);
                      }}
                    >
                      <div
                        style={{
                          textAlign: "left",
                          color: !obj.exists ? "#666" : "white",
                          width: 60,
                        }}
                      >
                        {obj.ticker.split(" ")[0]}
                      </div>
                      <div
                        style={{
                          color: "#666666",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "left",
                          textTransform: "capitalize",
                          marginRight: 10,
                          maxWidth: 260,
                          position: "relative",
                        }}
                      >
                        {(obj.name.length > 20) &
                        window.matchMedia("(max-width: 480px)").matches
                          ? obj.name.substring(0, 20) + "..."
                          : obj.name}
                      </div>
                    </div>

                    {!obj.exists ? (
                      !obj.requested ? (
                        <div
                          className="request-button"
                          onClick={(e) => {
                            setModalRequestOpen(true);
                            setName(obj.name);
                            setTicker(obj.ticker);
                            setResults([]);
                            setSearch("");
                          }}
                        >
                          Request
                        </div>
                      ) : (
                        <div
                          className="request-button"
                          style={{
                            color: "#666666",
                            cursor: "not-allowed",
                            backgroundColor: "transparent",
                          }}
                        >
                          Requested
                        </div>
                      )
                    ) : (
                      <div
                        style={{
                          color: obj.ticker ? "#98CD4B" : "transparent",
                          textAlign: "right",
                          position: "relative",
                          left: -7,
                        }}
                        onClick={async (e) => {
                          if (!obj.exists || addedTicker) return;
                          //Add the ticker!
                          const data = await API.graphql(
                            graphqlOperation(`mutation {
                        add_ticker(object: {ticker: "${obj.ticker}", panel_id: "${props.tab.id}"}) {
                          message
                          tickers_left
                          total_tickers
                          upgrade_plan_key
                          upgrade_plan_title
                          upgrade_message
                          payment_confirmation_message
                          payment_success_message
                        }
                      }`),
                          );
                          setTicker(obj.ticker);
                          setResponse(data.data.add_ticker);
                          setSearch("");
                          setResults([]);
                          setTickerAlert(false);
                          setModalOpen(true);
                          props.setRefreshTable(new Date());
                        }}
                      >
                        {addedTicker ? (
                          <i className="fas fa-check-circle" />
                        ) : (
                          "+"
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
              <p
                style={{
                  color: "#666",
                  padding: window.matchMedia("(max-width: 480px)").matches
                    ? "10px 0px 10px 45px"
                    : "10px 0px 10px 70px",
                  fontSize: "12px",
                  fontStyle: "italic",
                  fontWeight: "bold",
                  letterSpacing: 0.5,
                }}
                onClick={(e) => {
                  setIsOpen(true);
                  setLoading(false);
                  setSearch("");
                  setResults([]);
                }}
              >
                Don't see it on this list?
                <span style={{ color: "#75CE41", fontStyle: "italic" }}>
                  &nbsp;&nbsp;Email us
                </span>
              </p>
            </div>
          ) : search !== "" ? (
            <div
              className="search-results"
              style={{
                position: "absolute",
                // right: 40,
                // top: 140,
                backgroundColor: "#2e2e2e",
                zIndex: 4,
                width: !window.matchMedia("(max-width: 480px)").matches
                  ? 400
                  : "295px",
                cursor: "pointer",
              }}
            >
              <p
                style={{
                  color: "#666",
                  padding: window.matchMedia("(max-width: 480px)").matches
                    ? "10px 0px 10px 45px"
                    : "10px 0px 10px 70px",
                  fontSize: "12px",
                  fontStyle: "italic",
                  fontWeight: "bold",
                  letterSpacing: 0.5,
                }}
                onClick={(e) => {
                  setIsOpen(true);
                  setLoading(false);
                  setSearch("");
                  setResults([]);
                }}
              >
                Don't see it on this list?
                <span style={{ color: "#75CE41", fontStyle: "italic" }}>
                  &nbsp;&nbsp;Email us
                </span>
              </p>
            </div>
          ) : null}
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen}
        // onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customModalStyles}
        contentLabel="Example Modal"
      >
        {!success ? (
          <div className="help-modal">
            <div className="modal-header">
              <h2 className="header-title">Request Unlisted Ticker</h2>
              <i onClick={closeModal} className="fas fa-times"></i>
            </div>
            {loading ? (
              <Loading variant="modal" />
            ) : (
              <div className="modal-content">
                <div className="header-text">
                  Don't see a ticker available to add or request? Open a ticket
                  and we'll look into it.
                </div>

                <form>
                  <div className="subject-text">Ticker Symbol</div>
                  <input
                    style={{}}
                    value={subject}
                    onChange={(e) => {
                      setSubject(e.target.value);
                    }}
                    className="subject-input"
                  />
                  {tickerSymbolInputEmpty ? (
                    <div
                      style={{
                        color: "#d33541",
                        position: "relative",
                        top: -10,
                      }}
                    >
                      Must include a Ticker Symbol
                    </div>
                  ) : null}
                  <div className="subject-text">
                    Anything to add about this request?
                  </div>
                  <textarea
                    value={message}
                    onChange={(e) => {
                      setMessage(e.target.value);
                    }}
                    className="help-input"
                  />
                </form>
                <div className="buttons">
                  <div onClick={submit} className="button-send">
                    Send
                  </div>
                  <div onClick={closeModal} className="button-cancel">
                    Cancel
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="help-modal">
            <div className="modal-header">
              <i onClick={closeModal} className="fas fa-times"></i>
            </div>
            <div className="modal-content-thank-you">
              <i className="header-icon-thank-you justify-center envelope-icon far fa-envelope"></i>
              <div className="header-text-thank-you">Message received.</div>
              <div className="body-text-thank-you">
                We've received your message and have sent you a confirmation
                email to <div className="email">{email}</div>. Someone from our
                team will follow up with you within the next 48 hours.
              </div>
            </div>
          </div>
        )}
      </Modal>
      {!tickerAlert && response.tickers_left <= 3 ? (
        <TickerAlert
          setTickerAlert={setTickerAlert}
          response={response}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          ticker={ticker}
          setRefreshTable={props.setRefreshTable}
        />
      ) : null}
      {modalRequestOpen ? (
        <RequestTickerAlert
          setModalOpen={setModalRequestOpen}
          modalOpen={modalRequestOpen}
          ticker={ticker}
          name={name}
          email={email}
        />
      ) : null}
    </>
  );
}
export default React.memo(KissViewAndTicker);
